import { Slot } from '@radix-ui/react-slot';
import { type ComponentPropsWithRef, type ReactNode } from 'react';

import { Button } from '@repo/ui/Button';
import { usePopover } from '@repo/ui/Popover/PopoverRoot';

export type PopoverTriggerProps = ComponentPropsWithRef<'button'> & {
  asChild?: boolean;
  className?: string;
  children: ReactNode;
};

export const PopoverTrigger = (props: PopoverTriggerProps) => {
  const { asChild, children, className = '', ...attrs } = props;
  const { id, triggerRef } = usePopover();

  const Component = asChild ? Slot : Button;

  return (
    <Component
      className={className}
      popoverTarget={id}
      ref={triggerRef}
      {...attrs}
    >
      {children}
    </Component>
  );
};
